export const UPDATE_GAME_DETAIL_DASHBOARD_LOADING = "UPDATE_GAME_DETAIL_DASHBOARD_LOADING"
export const GET_GAME_DETAIL_DASHBOARD = "GET_GAME_DETAIL_DASHBOARD"
export const UPDATE_REQUEST_DASHBOARD = "UPDATE_REQUEST_DASHBOARD"
export const UPDATE_REPORT_LIST_PAGINATION = "UPDATE_REPORT_LIST_PAGINATION"
export const CLEAR_REQUEST_DASHBOARD = "CLEAR_REQUEST_DASHBOARD"